import React, { useState } from 'react';
import { Input, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styleCellTitle } from '../../../../../components/bonus/ui/styles';
import { getNumberValue } from '../../../../../utils';
import BtnTrash from '../../../../../components/bonus/ui/BtnTrash';
import CurrencySelect from '../../../../../components/shared/CurrencySelect';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import Table from '../../../../../components/material-ui/adaptive/Table';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import FreeSpinSelect from '../../../../../components/shared/FreeSpinSelect';
import BtnPlus from '../../../../../components/bonus/ui/BtnPlus';

export default function WelcomePackets({
  bonus,
  id,
  getPackageInfo,
  changeFieldPackage,
  onDelete,
  group,
  selectCurrency,
  setSelectCurrency
}) {
  const { t } = useTranslation();
  const { isLessTablet } = useBootstrapSize();
  const currencies = bonus?.values;

  const onPlusClick = (id, currency, indx) => {
    changeFieldPackage(id, currency, indx, 'minDeposit', 1);
    changeFieldPackage(id, currency, indx, 'maxDeposit', 1);
    changeFieldPackage(id, currency, indx, 'toDeposit', false);
    changeFieldPackage(id, currency, indx, 'percent', 1);
    changeFieldPackage(id, currency, indx, 'wager', 1);
    changeFieldPackage(id, currency, indx, 'cashout', 1);
    changeFieldPackage(id, currency, indx, 'campaignId', undefined);
  };

  const onTrashClick = (id, currency, indx) => {
    onDelete(id, currency, indx);
  };

  const changeField = (indx, name, value) => {
    let newValue = value ? getNumberValue(value) : null;
    if (['maxDeposit', 'cashout'].includes(name)) {
      newValue = value ? Math.abs(value) : null;
    }

    changeFieldPackage(id, selectCurrency, indx, name, newValue);
  };

  const sxCell = isLessTablet ? { p: 1 } : { p: 2 };

  return (
    <TableContainer sx={{ minWidth: { sm: '350px' } }}>
      <Table>
        <TableHead>
          <TableRow>
            <MyTableCell style={styleCellTitle}>{t('Currency')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('Min deposit')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('Max deposit')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('To the deposit balance')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('% bonus from deposit amount')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('Wager')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('Cashout')}</MyTableCell>
            <MyTableCell style={styleCellTitle}>{t('FreeSpin')}</MyTableCell>
            <MyTableCell>
              <CurrencySelect
                value={selectCurrency}
                setValue={setSelectCurrency}
                id={'currencies_welcome'}
              />
            </MyTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {currencies[selectCurrency]?.map((_, indx) => {
            const packageInfo = getPackageInfo(id, selectCurrency, indx);
            const { minDeposit, maxDeposit, toDeposit, percent, wager, cashout, campaignId } =
              packageInfo;

            return (
              <TableRow key={`${id}-${indx}`}>
                <MyTableCell>
                  <b>{selectCurrency}</b>
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={minDeposit}
                    onChange={(e) => changeField(indx, 'minDeposit', +e.target.value)}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={maxDeposit}
                    onChange={(e) => changeField(indx, 'maxDeposit', +e.target.value)}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell align="center">
                  <CusCheckbox
                    checked={toDeposit}
                    onChange={(e) =>
                      changeFieldPackage(id, selectCurrency, indx, 'toDeposit', e.target.checked)
                    }
                  />
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={percent}
                    onChange={(e) => changeField(indx, 'percent', +e.target.value)}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={wager}
                    onChange={(e) => changeField(indx, 'wager', e.target.value)}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={cashout}
                    onChange={(e) => changeField(indx, 'cashout', e.target.value)}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell>
                  <FreeSpinSelect
                    id={'welcome_fs_' + indx}
                    groupId={group.groupId}
                    label=""
                    value={campaignId}
                    setValue={(val) => {
                      changeFieldPackage(id, selectCurrency, indx, 'campaignId', val);
                    }}
                    currency={selectCurrency}
                  />
                </MyTableCell>

                <MyTableCell>
                  <ShowContainer condition={indx}>
                    <BtnTrash onDelete={() => onTrashClick(id, selectCurrency, indx)} />
                  </ShowContainer>
                </MyTableCell>
              </TableRow>
            );
          })}
          <TableRow>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            <MyTableCell></MyTableCell>
            {/* <TableCell></TableCell> */}
            <MyTableCell>
              <BtnPlus
                onPlusClick={() =>
                  onPlusClick(id, selectCurrency, currencies[selectCurrency]?.length || 0)
                }
              />
            </MyTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
